import { Component, Mixins, Prop } from 'vue-property-decorator';

import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import NameRow from '@/forms/FormElements/Rows/NameRow/NameRow.vue';
import PhoneRow from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.vue';
import AddressRow from '@/forms/FormElements/Rows/AddressRow/AddressRow.vue';
import DebugModel from '@/forms/FormElements/Common/DebugModel/DebugModel.vue';
import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';

import { ContestEntry, names } from './ContestForm.types';
import Message from '@/forms/Validations/Message';
import getValidation from '@/modules/ContestFormModule/ContestForm/ContestForm.validations';
import { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  components: {
    DebugModel,
    NameRow,
    EmailRow,
    PhoneRow,
    AddressRow,
    TextRow,
    ButtonRow,
  },
})
export default class ContestForm extends Mixins(FormValidationMixin) {
  names = names;

  model: ContestEntry = model;

  messages: Message[] = messages;

  buttonStylePrimaryDarkBlack = CtaButtonStyle.PrimaryDarkBlack;

  setAndSubmit() {
    this.model.Tag = this.Tag;
    this.submit();
  }

  @Prop()
  readonly BottomText!: string;

  @Prop()
  readonly Tag!: string;


}
